module.exports = __webpack_public_path__ + "static/media/heroImage.7044008f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/heroImage.png
// module id = 497
// module chunks = 0